'use client'

import React, { useMemo } from 'react'

import { MSwiper, SwiperSlide } from '../../../components/swiper'
import { cn } from '../../../utils/cn'

import { DividerImagesAItem } from './_components'
import { isBlockValid } from './_utils/divider-images.utils'

import type { IMDividerImagesAProps } from './_types/types'

/**
 * MDividerImagesA – presentational highlights section.
 * Displays key features in a flex row on desktop and carousel on mobile.
 * Each item can have either an image or a title (number).
 * Based on medante-vital__highlights.
 */
export const MDividerImagesA: React.FC<IMDividerImagesAProps> = ({
	className,
	style,
	highlights
}) => {
	const validHighlights = useMemo(() => isBlockValid(highlights), [highlights])

	if (validHighlights.length === 0) {
		return null
	}

	return (
		<section className={cn('m-divider-images-a', className)} style={style}>
			{/* Desktop Grid View */}
			<div className='m-divider-images-a__content m-divider-images-a__content--desktop'>
				{validHighlights.map((highlight, index) => (
					<DividerImagesAItem
						key={`desktop-${highlight.description}-${index}`}
						highlight={highlight}
					/>
				))}
			</div>

			{/* Mobile Carousel View */}
			<div className='m-divider-images-a__content m-divider-images-a__content--mobile'>
				<MSwiper
					spaceBetween={16}
					slidesPerView={1}
					autoplay={true}
					autoplayDelay={2500}
					loop={true}
				>
					{validHighlights.map((highlight, index) => (
						<SwiperSlide key={`mobile-${highlight.description}-${index}`}>
							<DividerImagesAItem highlight={highlight} />
						</SwiperSlide>
					))}
				</MSwiper>
			</div>
		</section>
	)
}

MDividerImagesA.displayName = 'MDividerImagesA'
